import { useState } from "react";
import PropTypes from "prop-types";
import { BbotButton, BbotModal, Input } from "top-component-library";
import { FormRow } from "../styles";

// Mirrors confirmDeleteStation()'s $mdDialog.prompt() path, only reached for a station that
// has received orders - a station with no orders deletes immediately with no prompt at all
// (see StationsCard), matching legacy exactly.
const DeleteStationDialog = ({ station, onClose, onConfirm }) => {
  const [typedName, setTypedName] = useState("");
  const [deleting, setDeleting] = useState(false);

  const handleConfirm = async () => {
    if (typedName !== station.station_name) {
      return;
    }
    setDeleting(true);
    const succeeded = await onConfirm(station);
    setDeleting(false);
    if (succeeded) onClose();
  };

  return (
    <BbotModal
      title="Are you sure you want to delete this station?"
      visible
      onCancel={onClose}
      footer={[
        <BbotButton key="cancel" onClick={onClose}>
          Never mind, go back!
        </BbotButton>,
        <BbotButton
          key="confirm"
          type="primary"
          danger
          loading={deleting}
          disabled={typedName !== station.station_name}
          onClick={handleConfirm}
        >
          Confirm
        </BbotButton>,
      ]}
    >
      <FormRow>
        <label htmlFor="delete-station-confirm-name">
          The station has received orders, please type in the station name to confirm:
        </label>
        <Input
          id="delete-station-confirm-name"
          placeholder={station.station_name}
          value={typedName}
          onChange={(event) => setTypedName(event.target.value)}
        />
      </FormRow>
    </BbotModal>
  );
};

DeleteStationDialog.propTypes = {
  station: PropTypes.shape({
    id: PropTypes.string.isRequired,
    station_name: PropTypes.string.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default DeleteStationDialog;
